import { render, staticRenderFns } from "./addTypeView.vue?vue&type=template&id=aed7c656&scoped=true&"
import script from "./addTypeView.vue?vue&type=script&lang=js&"
export * from "./addTypeView.vue?vue&type=script&lang=js&"
import style0 from "./addTypeView.vue?vue&type=style&index=0&id=aed7c656&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed7c656",
  null
  
)

export default component.exports